import { useEffect, useMemo, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import {
  MOBILE_DEVICE_DIMENSIONS,
  POPUP_MESSAGES_IMAGES,
  REFERRALS_IMAGES,
  NOTIFICATION_IMAGES,
} from '../utils/mobileDevices';
import { getHTMLBody, getHTMLWrapper } from '../utils/strings';

function HTMLPreview({ value, preview, setPreview, type, title }) {
  const iframeRef = useRef(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const initIframeValue = useMemo(() => getHTMLWrapper(getHTMLBody(value)), []);

  useEffect(() => {
    if (iframeRef.current?.contentWindow?.document?.body) {
      iframeRef.current.contentWindow.document.body.innerHTML = value;
    }
  }, [value]);

  const titleStyle = useMemo(() => {
    const { scale } = MOBILE_DEVICE_DIMENSIONS[preview.device];

    if (type === 'notification') {
      const { maxWidth, minWidth, top, left } = NOTIFICATION_IMAGES[preview.device].titleStyle;

      return {
        height: 44,
        minWidth,
        maxWidth,
        backgroundColor: '#17BEBB',
        color: '#350569',
        position: 'absolute',
        top,
        left,
        fontWeight: '600',
        fontSize: 18,
        paddingTop: 8,
        paddingLeft: 19,
        transform: `scale(${scale})`,
      };
    }

    return null;
  }, [preview.device, type]);

  const iframeStyle = useMemo(() => {
    const { scale } = MOBILE_DEVICE_DIMENSIONS[preview.device];

    if (type === 'referrals') {
      return {
        top: REFERRALS_IMAGES[preview.device].iframeStyle.top,
        left: (preview.width * (1 - 1 / scale)) / 2,
        width: preview.width * (1 / scale) - 1,
        height: preview.height - REFERRALS_IMAGES[preview.device].iframeStyle.spacing,
        transform: `scale(${scale})`,
      };
    }

    if (type === 'popup') {
      return {
        borderRadius: 10,
        padding: 20,
        top: POPUP_MESSAGES_IMAGES[preview.device].iframeStyle.top,
        left: (preview.width * (scale - 0.85)) / (2 * scale),
        width: preview.width * (1 / scale) * 0.85 - 1,
        height: preview.height - POPUP_MESSAGES_IMAGES[preview.device].iframeStyle.spacing,
        transform: `scale(${scale})`,
      };
    }

    if (type === 'notification') {
      return {
        paddingLeft: 12,
        paddingRight: 12,
        top: NOTIFICATION_IMAGES[preview.device].iframeStyle.top,
        left: (preview.width * (1 - 1 / scale)) / 2,
        width: preview.width * (1 / scale) - 1,
        height: preview.height - NOTIFICATION_IMAGES[preview.device].iframeStyle.spacing,
        transform: `scale(${scale})`,
      };
    }

    return null;
  }, [preview, type]);

  return (
    <div>
      <div className="d-flex justify-content-end align-items-end mb-2">
        <Form.Select
          className="bo-filter"
          value={preview.device}
          onChange={e =>
            setPreview({
              device: e.target.value,
              width:
                MOBILE_DEVICE_DIMENSIONS[e.target.value].viewport_width *
                MOBILE_DEVICE_DIMENSIONS[e.target.value].scale,
              height:
                MOBILE_DEVICE_DIMENSIONS[e.target.value].viewport_height *
                MOBILE_DEVICE_DIMENSIONS[e.target.value].scale,
            })
          }
        >
          {Object.entries(MOBILE_DEVICE_DIMENSIONS).map(([key, v]) => (
            <option key={key} value={key}>
              {v.name}
            </option>
          ))}
        </Form.Select>
      </div>
      <div className="position-relative">
        {type === 'referrals' && (
          <img
            // eslint-disable-next-line import/no-dynamic-require, global-require
            src={require(`../assets/editor/devices/${REFERRALS_IMAGES[preview.device].name}`)}
            alt={REFERRALS_IMAGES[preview.device].alt}
            className="bo-common-iframe-container"
            style={{ width: preview.width, height: preview.height }}
          />
        )}
        {type === 'popup' && (
          <img
            // eslint-disable-next-line import/no-dynamic-require, global-require
            src={require(`../assets/editor/devices/${POPUP_MESSAGES_IMAGES[preview.device].name}`)}
            alt={POPUP_MESSAGES_IMAGES[preview.device].alt}
            className="bo-common-iframe-container"
            style={{ width: preview.width, height: preview.height }}
          />
        )}
        {type === 'notification' && (
          <>
            <div style={titleStyle}>
              <p className="text-truncate">{title}</p>
            </div>
            <img
              // eslint-disable-next-line import/no-dynamic-require, global-require
              src={require(`../assets/editor/devices/${NOTIFICATION_IMAGES[preview.device].name}`)}
              alt={NOTIFICATION_IMAGES[preview.device].alt}
              className="bo-common-iframe-container"
              style={{ width: preview.width, height: preview.height }}
            />
          </>
        )}
        <iframe
          ref={iframeRef}
          title="HTML Preview"
          className="position-absolute bg-white"
          style={iframeStyle}
          onLoad={ev => {
            const new_style_element = document.createElement('style');

            new_style_element.textContent = 'body { line-height: 1.55; }';
            ev.target.contentDocument.head.appendChild(new_style_element);
          }}
          srcDoc={initIframeValue}
        />
      </div>
    </div>
  );
}

export default HTMLPreview;
